import { render, staticRenderFns } from "./batchImportPolicyFile.vue?vue&type=template&id=36424463&scoped=true"
import script from "./batchImportPolicyFile.vue?vue&type=script&lang=js"
export * from "./batchImportPolicyFile.vue?vue&type=script&lang=js"
import style0 from "./batchImportPolicyFile.vue?vue&type=style&index=0&id=36424463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36424463",
  null
  
)

export default component.exports